import { render } from "./LoginDialog.vue?vue&type=template&id=46be67e7"
import script from "./LoginDialog.vue?vue&type=script&lang=js"
export * from "./LoginDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__